// 销售状态部分1
window.ProductSalesStatus = new window.ProductSalesStatus();

 /**
  * 更新paypal支付
  **/
  function updatePaypal(params) {
    try {
      paypal.Messages({
        amount: params,
        style: { layout: "text", logo: { type: "primary" }, text: { color: "black", size: 14 } }
      }).render('#is-paypal');
    } catch (error) {
      console.error('Error rendering PayPal messages:', error);
    }
  }
class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.fixSlideClick();
    
    // 更新选择的产品图
    const featuredMediaId = document.querySelector('[data-selected-featured_media]').dataset.selectedFeatured_media;
    if (featuredMediaId) {
      this.fixSlide(featuredMediaId);
    }
    this.main = this.closest("main-product");
    this.updateCode()
  }
  
  /**
   * 更新变体
   */
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    // this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      // 销售状态部分2
      window.ProductSalesStatus.updateStatus(this.currentVariant.id, this.currentVariant);
    }
    this.updateCode()
  }
  
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('[data-options]'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
  
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  
  /**
   * 跟新变体图片
   */
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    this.fixSlide(this.currentVariant.featured_media.id);
    // const parent = newMedia.parentElement;
    // parent.prepend(newMedia);
    // window.setTimeout(() => { parent.scroll(0, 0) });
  }
  
  /**
   * 修复滚动提示
   */
  fixSlide(id) {
    const slideshowElement = document.querySelector(`.tm-main-product [uk-slideshow]`)
    const sliderElement = document.querySelector(`.tm-main-product [uk-slider]`)
    const oLis = UIkit.util.queryAll(`.tm-main-product [uk-slider] img`);
    const selectSlide = document.querySelector(`[data-thumbnail-id="${id}"] img`);
    const newMedia = document.querySelector(`[data-media-id="${this.dataset.section}-${id}"]`);
    const imageIndex = newMedia.dataset.imageIndex;
    if (!newMedia) return;
    UIkit.util.removeClass(oLis, 'tm-active');
    selectSlide.classList.add('tm-active');
    
    UIkit.slideshow(slideshowElement).show(imageIndex);
    UIkit.slider(sliderElement).show(imageIndex);
  }
  
  fixSlideClick() {
    const sliderElement = document.querySelector(`#shopify-section-${this.dataset.section} [uk-slider]`);
   
    const oLis = UIkit.util.queryAll(`#shopify-section-${this.dataset.section} [uk-slider] img`);
   
    UIkit.util.on(oLis, 'click', (event) => {
      const index = event.target.closest('li').getAttribute('uk-slideshow-item');
      const imageIndex = event.target.closest('li').dataset.thumbnailId;
      UIkit.slider(sliderElement).show(index);

      this.fixSlide(imageIndex);
    })
    
  }
  
  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  
  /**
   * 更新快速结账匹配产品ID
   */
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', {bubbles: true}));
    });
  }
  
  // updatePickupAvailability() {
  //   const pickUpAvailability = document.querySelector('pickup-availability');
  //   if (!pickUpAvailability) return;
  //
  //   if (this.currentVariant?.available) {
  //     pickUpAvailability.fetchAvailability(this.currentVariant.id);
  //   } else {
  //     pickUpAvailability.removeAttribute('available');
  //     pickUpAvailability.innerHTML = '';
  //   }
  // }
  
  /**
   * 更新产品状态
   * @returns {Promise<void>}
   */
  async renderProductInfo() {
    const url = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;
    const id = `price-${this.dataset.section}`;
    const destination = document.getElementById(id);
    
    // 更新paypal支付
    updatePaypal(this.currentVariant.price / 100);
    
    this.source = await fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        return html.getElementById(id);
      });
    if (this.source && destination) destination.innerHTML = this.source.innerHTML;
    document.getElementById(`price-${this.dataset.section}`).classList.remove('visibility-hidden');
    this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
  }
  
  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]');
    const addButtonInnerHtml = document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]').querySelector('span');
    
    if (!addButton) return;
    
    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButtonInnerHtml.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonInnerHtml.textContent = window.variantStrings.addToCart;
    }
    
    if (!modifyClass) return;
  }
  
  
  /**
   * 变体不存在时禁用按钮和价格
   */
  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]');
    const addButtonInnerHtml = document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]').querySelector('span');
    if (!addButton) return;
    addButtonInnerHtml.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`).classList.add('uk-hidden');
  }
  
  /**
   * 获取产品json并缓存
   * @returns {*}
   */
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  
  /**
   * 购物车超过库存数量时提示错误信息
   */
  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;
    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  /**
  * 变体折扣码
  */
  updateCode() {
      let tm_discount =  this.main.querySelector('.tm-discount-variant')
      let tm_discount_code =  this.main.querySelector('.tm-discount-code')
      let tm_discount_date =  this.main.querySelector('.tm-discount-date')
      let tm_discount_des =  this.main.querySelector('.tm-discount-des')
      let tm_discount_coupon =  this.main.querySelector('.tm-discount-coupon')
      const url = window.location.href;
      const { url: urlWithoutParams, paramValue } = this.parseUrl(url, 'variant');
      fetch(`${urlWithoutParams}?view=json`)
      .then(response => response.json())
      .then(responseData => {
        // 在此处对 responseData 进行处理
        if(responseData && responseData.coupon != null) {
          let coupon = responseData.coupon
          const foundObjs = coupon.filter(obj => obj.hasOwnProperty(paramValue));
            if (foundObjs.length > 0 && foundObjs[0][paramValue] != null) {
              if(tm_discount) tm_discount.setAttribute("style", "display: block !important");
              tm_discount.dataset.discount = foundObjs[0][paramValue].code;
              tm_discount_code.innerHTML = foundObjs[0][paramValue].code;
              tm_discount_date.innerHTML = foundObjs[0][paramValue].start + '~' + foundObjs[0][paramValue].end;
              tm_discount_des.innerHTML = foundObjs[0][paramValue].des;
              tm_discount_coupon.innerHTML = foundObjs[0][paramValue].coupon;
            } else {
              if(tm_discount) tm_discount.setAttribute("style", "display: none !important");
            }
        } else {
          if(tm_discount) tm_discount.setAttribute("style", "display: none !important")
        }
      });
    }
    removeQueryParams(url) {
      const index = url.indexOf('?');
      if (index !== -1) {
        return url.substring(0, index);
      } else {
        return url;
      }
    }
    parseUrl(url, paramName) {
      const urlObj = new URL(url);
      const params = new URLSearchParams(urlObj.search);
      const paramValue = params.get(paramName);
      return {
        url: urlObj.origin + urlObj.pathname,
        paramValue: paramValue
      };
    }
}

customElements.define('variant-radios', VariantRadios);

class MainProduct extends HTMLElement {
  constructor() {
    super();
        
      //初始化paypal支付信息
    const paypalPrice = JSON.parse(this.dataset.product);
    updatePaypal(paypalPrice.price)
    this.selectors = {
      slideshowElement: this.querySelector('[uk-slideshow]'),
      sliderElement: this.querySelector('[uk-slider]')
    }
  
    this.fixSlideClick();

    // 销售状态部分3
    window.ProductSalesStatus.init();
  }
  
  fixSlideClick() {
    const oLis = UIkit.util.queryAll('[uk-slider] img');
    UIkit.util.on(oLis, 'click', (event) => {
      const index = event.target.closest('li').getAttribute('uk-slideshow-item');
      const imageIndex = event.target.closest('li').dataset.thumbnailId;
      UIkit.slider(this.selectors.sliderElement).show(index);
      this.fixSlide(imageIndex);
    })
  }
  
  /**
   * 修复滚动提示
   */
  fixSlide(id) {
    const oLis = UIkit.util.queryAll('[uk-slider] img');
    const selectSlide = this.querySelector(`[data-thumbnail-id="${id}"] img`);
    const newMedia = this.querySelector(`[data-media-id="${this.dataset.sectionId}-${id}"]`);
    const imageIndex = newMedia.dataset.imageIndex;
    if (!newMedia) return;
    UIkit.util.removeClass(oLis, 'tm-active');
    selectSlide.classList.add('tm-active');
    UIkit.slideshow(this.selectors.slideshowElement).show(imageIndex);
    UIkit.slider(this.selectors.sliderElement).show(imageIndex);
  }
}

customElements.define('main-product', MainProduct);
